//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ComparePrice',
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      selectedInterval: '24h',
      intervals: ['24h'],
      percent: null,
      wantedPercent: null
    }
  },
  computed: {
    lowest () {
      if (this.tetherData) {
        return this.tetherData.low
      } else if (!this.data.digital) {
        return this.data.low_24h
      } else {
        return this.data.digitalData[this.data.title + '_sell_price']
      }
    },
    highest () {
      if (this.tetherData) {
        return this.tetherData.high
      } else if (!this.data.digital) {
        return this.data.high_24h
      } else {
        return this.data.digitalData[this.data.title + '_buy_price']
      }
    }
  },
  // watch: {
  //   selectedInterval (val) {
  //     if (val === '24h') {
  //       this.lowest = this.data.price < this.data.low_24h ? this.data.price : this.data.low_24h
  //       this.highest = this.data.price > this.data.high_24h ? this.data.price : this.data.high_24h
  //     } else if (val === '7d') {
  //       this.lowest = this.data.price < this.data.low_7d ? this.data.price : this.data.low_7d
  //       this.highest = this.data.price > this.data.high_7d ? this.data.price : this.data.high_7d
  //     } else if (val === '30d') {
  //       this.lowest = this.data.price < this.data.low_30d ? this.data.price : this.data.low_30d
  //       this.highest = this.data.price > this.data.high_30d ? this.data.price : this.data.high_30d
  //     }
  //     this.nowPercent(this.highest, this.lowest)
  //   }
  // },
  created () {
    if (this.highest && this.lowest) {
      this.nowPercent(this.highest, this.lowest)
    }
  },
  methods: {
    nowPercent (high, low) {
      if (this.tetherData) {
        this.wantedPercent = (Number((((+this.tetherData.close - low) / (high - low)) * 100).toFixed(0)))
      } else {
        this.wantedPercent = !this.data.digital ? (Number((((+this.data.price - low) / (high - low)) * 100).toFixed(0))) : (Number((((((+this.data.digitalData[this.data.title + '_buy_price'] + this.data.digitalData[this.data.title + '_sell_price']) / 2) - low) / (high - low)) * 100).toFixed(0)))
      }
      this.percent = this.wantedPercent < 0 ? 0 : this.wantedPercent > 100 ? 100 : this.wantedPercent
    }
  }
}
